import { newInstance, autoinject, computedFrom, observable } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { Router, Redirect, activationStrategy } from 'aurelia-router';
import { DialogService } from 'aurelia-dialog';
import { CarriersController } from "../controllers/carriers-controller";
import { BusyService } from "../services/busy-service";
import { Carrier } from "../models/carrier";
import { PromptDialog } from "../resources/dialogs/prompt-dialog";
import { NewCommentDialog } from "./dialogs/new-comment-dialog";
import { SaveChangesDialog } from "./dialogs/save-changes-dialog";
import { SimpleDialog } from "./dialogs/simple-dialog";
import { CarrierStatusDialog } from "./dialogs/carrier-status-dialog";
import { CarrierExistsDialog } from "./dialogs/carrier-exists-dialog";
import { UpdateContactDialog } from "./dialogs/update-contact-dialog";
import { UpdateInsuranceDialog } from "./dialogs/update-insurance-dialog";
import { WebApiService } from "../services/web-api-service";
import { PageMessageService } from "../services/page-message-service";
import { SecurityService } from "../services/security-service";
import { AppMessageService } from "../services/app-message-service";
import lanes from "../models/lane-list";
import { CommentEntry } from "../models/comment-entry";
import { Contact } from "../models/contact";
import { PhoneValueConverter } from "../resources/value-converters/phone";
import { PushMessage, SignalrService } from '../services/signalr-service';
import { SettingsService } from '../services/settings-service';
import * as AppMessage from '../models/app-message';
import 'jquery';
import 'notify';
import * as moment from 'moment';
import { SearchCarrierDialog } from './dialogs/search-carrier';
import { DedicatedScacDialog } from './dialogs/update-dedicated-scac';
import { UpdateTransloaderLocationDialog } from './dialogs/update-transloader-details-dialog';
import { TonnageDetailsDialog } from './dialogs/tonnage-details-dialog';
import { OrgStructureNode } from '../models/org-structure-node';
import { Globals } from '../models/globals';
import { CreateCarrierDialog } from './dialogs/create-carrier-dialog';
import { AddRemoveCarrierDivisionDialog } from './dialogs/add-remove-carrier-division';
// import { WorkflowActions } from './widgets/NOT_USED_workflow-actions';
import { RequestDto } from '../data/typegen/dtos/request-dto';
import { TaskAssignmentGroups } from '../data/typegen/enums/task-assignment-groups';
import { CarrierOnboardingStatusSummaryDialog } from './dialogs/carrier-onboarding-status-summary';
import { OnboardingRequirements } from './widgets/onboarding-requirements/onboarding-requirements';
import { ApiResultStatus } from '../data/enums/apiResultStatus';
import { UpdateAdditionalMcNumberDialog } from './dialogs/update-additional-mc-number-dialog';

@autoinject()
export class WorkCarrier {
    hasInsuranceThatNeedsReview: boolean;
    hasBrokerInsurance: boolean;
    hasCarrierInsurance: boolean;
    insuranceForReview: any[];
    brokerageInsurance: any[];
    assetCarrierInsurance: any[];
    transloaderLocationsGridOptions: any;
    heavyHaulerWeights: Array<any> = [];
    isDjjCarrier: boolean;
    selectedTab: any = "onboarding-requirements";
    familyTree: any;
    entityTypes: { id: string; description: string; }[];
    isCarrierEnabledForMyMill: boolean;
    carrierCommentTagCount: {};

    public readonly REQUEST_TYPE_ID_CARRIER_ONBOARDING = '2c837aa3-48a5-4a66-8a9f-a70d04d0a8b8';

    public currentCarrierRequest: RequestDto;
    /** Indicate whether the carrier is in a current onboarding, reevaluation, insurance renewal, etc request */
    public carrierIsOnboarding = false;
    public onboardingRequirementsOptions = { statusIcon: "", class: "" };
    public onboardingRequirementsComponent: OnboardingRequirements;

    public tmsFlag: boolean;
    primaryAgentOptGroups: any = [];


    determineActivationStrategy() {
        return activationStrategy.replace;
    }

    public showOnboardingRequirements = false;

    constructor(
        private ea: EventAggregator,
        private carriersController: CarriersController,
        private busyService: BusyService,
        private pageMessageService: PageMessageService,
        private dialogService: DialogService,
        private router: Router,
        private api: WebApiService,
        private signalr: SignalrService,
        private appMessageService: AppMessageService,
        public settingsService: SettingsService,
        private securityService: SecurityService) {

        this.lanes = lanes;

        this.entityTypes = new Globals().getEntityTypes();
    };


    public transloaderLocations: Array<any> = [];

    carrierPointUrl: "";
    states: Array<any>;
    carrier: Carrier = new Carrier();
    carrierEquipment: Array<any> = [];
    originalCarrierEquipment: Array<any> = [];
    carrierDivisions: Array<any> = [];
    originalCarrierDivisions: Array<any> = [];
    //carrierEndorsements: Array<any> = [];
    carrierDocuments: Array<any> = [];
    @computedFrom("carrierDocuments.length", "carrier.entityType")
    get filteredCarrierDocuments(): Array<any> {
        return this.carrierDocuments.filter(o => this.canShowDocument(o));
    }
    carrierInboundLanes: Array<any> = [];
    carrierOutboundLanes: Array<any> = [];
    carrierInsurance: Array<any> = [];
    carrierActivityStream: Array<any> = [];
    contacts: Array<Contact> = [];
    equipmentTypes: Array<any> = [];
    countries = [];
    carrierCountriesOfOperation = [];
    productGroups: Array<any> = [];
    railCarTypes: Array<any> = [];
    lanes: Array<any>;
    carrierId: number;
    originalCarrierStatus: any;
    carrierStatuses: any;
    carrierShipHistory = {};
    //insuranceTypes: any;
    //@observable
    //carrierInsurance: any = [];
    editMode: string;
    fieldApprovals: any = {};
    dotValues: any = {};
    dotMatches: any = {};
    // isCarrierFullyApproved: boolean = null;
    divisions: Array<any> = [];
    isSaveDisabled: boolean;
    gridRows: Array<any> = [];
    @observable()
    currentRecordIndex: number = -1;
    originalCarrierJson: any;
    commentTagFilter: string = "All";


    dotNumberReadonly: boolean;
    scacCodeReadonly: boolean;
    taxIdReadonly: boolean;




    public diversityCategories = [
        { name: "Minority Owned", value: "87eb5c19-cf2d-4b0f-a2a4-8d246251e95e" },
        { name: "Woman Owned", value: "99d55403-4eef-4e80-ba5d-f8c6831d92a6" },
        { name: "Veteran Owned", value: "83624890-38e7-44d1-b1d8-be6446324cc9" }
    ]


    tabClicked(tab) {
        this.selectedTab = tab;
    }

    events = {
        carrierLoading: "carrierLoading"
    }

    public insuranceSyncNeeded: boolean = false;

    primaryAgentOverridden(overridden: boolean) {
        if (this.carrier.primaryAgentId) {
            this.carrier.primaryAgentIdOverridden = overridden;
        } else {
            this.carrier.primaryAgentIdOverridden = false;
        }
    }

    currentRecordIndexChanged() {
        window["$"](this.tooltipSelector)["tooltip"]("hide");
    }

    @computedFrom("carrierActivityStream.length", "commentTagFilter")
    get filteredCarrierComments(): Array<any> {
        const comments = this.carrierActivityStream.filter(c => (c.tags || "").indexOf("ChangeLog") == -1);
        if (this.commentTagFilter == "All") {
            return comments;
        }

        return comments.filter((c) => {
            return c.type == "comment" && c.tags && c.tags.toLowerCase().indexOf(this.commentTagFilter.toLowerCase()) > -1;
        });
    }

    @computedFrom("carrierActivityStream.length")
    get changeLogComments(): Array<any> {
        const changeComments = this.carrierActivityStream.filter(c => (c.tags || "").indexOf("ChangeLog") > -1);
        return changeComments;
    }

    @computedFrom("carrier.additionalMcNumbers", "carrier.mcNumber")
    get mcNumbersComputed(): string {
        const additionalMcNumbers = this.carrier.additionalMcNumbers || '';
        const additionalMcNumbersArray = additionalMcNumbers.split(',').map(num => num.trim());
        const mcNumbers = [this.carrier.mcNumber, ...additionalMcNumbersArray];
        return mcNumbers.filter(Boolean).join(", ");
    }


    private subscriptions: Array<Subscription> = [];
    subscribeEvents() {

        this.subscriptions.push(this.signalr.listen(PushMessage.CarrierUpdated, (message) => {
            if (this.carrier.id == message.data.id) {
                if (message.isThisUser) {
                    if (message.data.isFullReload) {
                        this.loadCarrierProfile(this.carrier.id);
                    } else {
                        Object.assign(this.carrier, message.data.carrierFields);
                        var originalObj = JSON.parse(this.originalCarrierJson);
                        Object.assign(originalObj.carrier, message.data.carrierFields);
                        this.setOriginalCarrierJson(originalObj);
                    }
                    this.loadCarrierActivityStream(this.carrier.uniqueId);
                }
                else if (this.carrier.versionCol != message.data.versionCol) {
                    this.appMessageService.addMessage(`This record has been updated by ${message.userName}.  Click Refresh to get the latest version.`, AppMessage.MessageType.critical, AppMessage.MessageLifetime.permanent, "concurrency_alert");
                    this.isSaveDisabled = true;
                }
            }
        }));

        this.subscriptions.push(this.signalr.listen(PushMessage.InsuranceUpdated, (message) => {
            if (this.carrier.id == message.data.carrierId) {
                this.loadCarrierInsurance(this.carrier.id);
                // only require to sync insurance if carrier is not in active onboarding
                if (!this.carrierIsOnboarding) {
                    this.insuranceSyncNeeded = true;
                }
                this.onboardingRequirementsComponent.refresh();
            }
        }));

        this.subscriptions.push(this.signalr.listen(PushMessage.CarrierDocumentsUpdated, (message) => {
            if (this.carrier.uniqueId == message.data.carrierGuid) {
                this.loadCarrierDocuments(this.carrier.uniqueId);
                this.onboardingRequirementsComponent.refresh();
            }
        }));
    }

    private setInsuranceSyncNeeded(isSyncNeeded: boolean) {
        if (this.carrier.status == 8 /* Master Approved */) {
            // set flag so that insurance sync alert and reminder is activated.
            this.insuranceSyncNeeded = isSyncNeeded;
        } else {
            // don't need to sync insurance unless if not master approved
            this.insuranceSyncNeeded = false;
        }
    }
    unsubscribeEvents() {
        this.subscriptions.forEach((sub) => sub.dispose());
        this.subscriptions = [];
    }

    activate(params: any) {

        this.subscribeEvents();


        this.carrierId = +params.carrierId;

        var json = localStorage.getItem("gridRows");
        if (json) {
            this.gridRows = JSON.parse(json);
            var row = this.gridRows.find((o, i) => {
                if (o.id == this.carrierId) {
                    this.currentRecordIndex = i;
                    return true;
                }
            });
        }

        this.loadEquipmentTypes();
        this.loadProductGroups();
        this.loadCountries();
        this.loadHeavyHaulerWeights();
        this.loadCarrierStatuses();
        //var insurancePromise = this.loadInsuranceTypes();
        this.loadDivisions();

        this.preInitTransloaderLocationsGrid();

        if (this.carrierId) {
            this.loadCarrierProfile(this.carrierId);
        } else {
            this.editMode = "New";
        }
    }

    nextRecord() {
        this.currentRecordIndex++;
        if (this.currentRecordIndex < this.gridRows.length) {
            var carrierId = this.gridRows[this.currentRecordIndex].Id;
            this.router.navigate(`work-carrier/${carrierId}`);
        }
    }

    prevRecord() {
        this.currentRecordIndex--;
        if (this.currentRecordIndex >= 0) {
            var carrierId = this.gridRows[this.currentRecordIndex].Id;
            this.router.navigate(`work-carrier/${carrierId}`);
        }
    }

    deactivate() {
        this.unsubscribeEvents();
    }

    tooltipSelector = 'a[data-toggle="tooltip"],button[data-toggle="tooltip"]';
    tooltipOptions = {
        delay: 200,
        trigger: 'hover'
    }

    attached() {

        //this.wfActionsRef.workCarrierComponent = this;

        //TODO: This should be a custom attribute
        //activate tooltips
        window["$"](this.tooltipSelector)["tooltip"](this.tooltipOptions);

        //TODO:  This needs to be binding-driven
        //(<any>$('.approved-Y>[data-toggle="tooltip"], .approved-N>[data-toggle="tooltip"]')).tooltip();

    }

    form_click(e) {
        let node: Element = e.target as Element;
        if (node && node.classList && node.getAttribute("field-approval") == "true") {
            var field = node.getAttribute("field");
            var approveAction = node.getAttribute("approve-action");
            this.approveField(field, approveAction);
        }

        return true;
    }

    approveField(fieldName, approveAction) {

        //re-fetch approvals
        this.loadCarrierFieldApprovals(this.carrier.id);


        //write the new approval to the server.
        this.pageMessageService.clear();
        this.api.post("Carriers", "WriteFieldApproval",
            {
                rowId: this.carrier.id,
                fieldName: fieldName,
                approval: approveAction
            })
            .then(() => {
                //re-fetch approvals
                this.loadCarrierFieldApprovals(this.carrier.id);
                //re-calc fully approved state
                // this.loadIsCarrierFullyApproved(this.carrier.id);
            });


    }

    //this is for create a new carrier (coming to this page with no carrierId specified)
    canActivate(params: any): any {
        var self = this;

        if (!+params.carrierId) {
            return new Promise((resolve, reject) => {
                this.dialogService.open(
                    {
                        viewModel: CreateCarrierDialog
                    })
                    .whenClosed((result) => {
                        if (!result.wasCancelled) {
                            return this.newCarrier(result.output)
                                .then(() => resolve(true), (redirect) => {
                                    if (redirect) {
                                        reject(redirect);
                                    } else {
                                        nope();
                                    }
                                });
                        }
                        else {
                            nope();
                        }
                    }, () => nope());

                function nope() {
                    //cannot activate
                    var history: any = self.router.history;
                    if (history.previousLocation) {
                        reject(false);
                    } else {
                        reject(new Redirect(""));
                    }
                }
            });
        }

        return true;
    }

    canShowDocument(document) {
        if (document.documentTypeCode == 'O') return false;

        if (this.isTransloaderCarrier) {
            return (document.documentTypeCode == 'FS'
                || document.documentTypeCode == 'IC'
                || document.documentTypeCode == 'W9'
                || document.documentTypeCode == 'HZ'
                || document.documentTypeCode == 'EF'
                || document.documentTypeCode == 'CT');
        }
        return (document.documentTypeCode != 'FS'
            && document.documentTypeCode != 'HZ');
    }


    newComment(id?: number) {
        this.dialogService.open(
            {
                viewModel: NewCommentDialog,
                model: [this.carrier.id, this.carrier.legalName, id]
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //reload carrier comments
                    this.loadCarrierActivityStream(this.carrier.uniqueId);
                }
            });
    }

    // public wfActionsRef: WorkflowActions;


    editNote(id: number) {
        this.newComment(id);
    }

    writeComment(comment, tags?) {
        var params = {
            carrierId: this.carrierId,
            comment: comment,
            tags: tags || []
        };

        return this.api.post("Carriers", "UpdateCarrierComment", params)
            .then(() => {
            }, () => {
                $["notify"]("Error writing comment", { className: "error", position: "top center" });
            });
    }

    requestContactChanges() {

        //const millCodeText = this.securityService.user.millCodes.join(",");
        var model = {
            title: "Request contact changes for this carrier on my division roster.",
            message: "Please describe the contact information changes you are requesting for this carrier:",
            showComment: true,
            comment: "",
            buttons: ["Send Request", "Cancel"]
        };

        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: model
            })
            .whenClosed((result) => {
                if (result.output == "Send Request") {
                    this.busyService.on();
                    return this.api.post("Carriers", "RequestCarrierContactChanges",
                        {
                            carrierId: this.carrierId,
                            carrierName: this.carrier.dbaName || this.carrier.legalName,
                            comment: model.comment
                        })
                        .then((result) => {
                            this.appMessageService.addSuccessMessage("Request sent.");
                        })
                        .finally(() => {
                            this.busyService.off();
                        });
                }
            });

    }

    requestCarrierAdd(add) {

        //const millCodeText = this.securityService.user.millCodes.join(",");
        var model = {
            add: add,
            carrierDivisions: this.carrierDivisions
        };
        return this.dialogService.open(
            {
                viewModel: AddRemoveCarrierDivisionDialog,
                model: model
            })
            .whenClosed((result) => {
                if (result.output) {
                    const divisionId = result.output;
                    this.busyService.on();
                    return this.api.post("Carriers", "AddRemoveCarrierDivision",
                        {
                            add: add,
                            carrierId: this.carrierId,
                            divisionId: divisionId
                        })
                        .then((result) => {
                            const verb = add ? "add" : "remov";
                            this.appMessageService.addSuccessMessage("This carrier has been " + verb + "ed for your roster.  Please refresh the page.");
                        })
                        .finally(() => {
                            this.busyService.off();
                        });
                }
            });

    }


    openContactDialog(contact: Contact) {
        this.dialogService.open({
            viewModel: UpdateContactDialog,
            model: {
                mills: this.divisions.filter((item) => this.carrierDivisions.indexOf(item.id) > -1),
                contact: contact,   //create a copy so that the original isn't modified
                carrierId: this.carrier.id
            }
        }).whenClosed(async (result) => {
            if (!result.wasCancelled) {
                //reload contacts
                await this.loadCarrierContacts(this.carrier.id);

                // reload carrier to get updated version col (this is updated because the last carrier activity date is updated when contacts are updated)
                await this.loadCarrierDetails(this.carrier.id);
            }
        });
    }

    public showTonsByDivision(range: "12months" | "90days") {
        this.dialogService.open(
            {
                viewModel: TonnageDetailsDialog,
                model: {
                    carrierId: this.carrier.uniqueId,
                    range: range,
                    carrierName: this.carrier.legalName || this.carrier.dbaName
                }
            });
    }


    openNewInsuranceDialog(authorityTypeId: string) {

        if (this.insuranceForReview.length > 0) {
            return alert("Complete all insurance review before adding new insurance");
        }

        var arr = [];

        if (authorityTypeId == "30d0f5ca-81a4-4540-b8a5-cf605bd523e8") {
            arr = this.assetCarrierInsurance;
        } else if (authorityTypeId == "ec8d37e1-a1ed-4187-9455-f41b8900088b") {
            arr = this.brokerageInsurance;
        } else {
            arr = this.insuranceForReview;
        }

        this.dialogService.open({
            viewModel: UpdateInsuranceDialog,
            model: {
                existingInsuranceTypeIds: arr.map(o => o.insuranceTypeId),
                carrierId: this.carrierId,
                carrier: this.carrier,
                authorityTypeId: authorityTypeId
            }
        }).whenClosed((result) => {
            if (!result.wasCancelled) {
                this.loadCarrierActivityStream(this.carrier.uniqueId);
                return true;
            }
        });
    }

    async syncAllInsuranceToCarrierPoint() {
        if (this.carrier.id) {
            this.busyService.on();
            try {
                var result = await this.api.post("Carriers", "SyncAllInsuranceToCarrierPoint", { id: this.carrier.id });
                this.appMessageService.addSuccessMessage(`Insurance info sent to Carrier Point`);
                //this.ea.publish("carrier.save", this.carrier);
                this.setInsuranceSyncNeeded(false);
                this.loadCarrierActivityStream(this.carrier.uniqueId);
            }
            catch (ex) {
                this.appMessageService.addErrorMessage(`Error sending insurance info to Carrier Point`);
                //scroll to top of page to ensure error is visible
                window.scrollTo(0, 0);
            }
            finally {
                this.busyService.off();
            }
        }
    }

    openInsuranceDialogByEndorsementType(endorsementTypeId) {
        var item = this.carrierInsurance.find(o => o.endorsements.find(e => e.endorsementTypeId == endorsementTypeId));
        if (item) {
            this.openInsuranceDialog(item);
        } else {
            alert("Insurance card not found for the requirement endorsement");
        }
    }

    openInsuranceDialog(item) {
        this.dialogService.open({
            viewModel: UpdateInsuranceDialog,
            model: {
                item: item,
                existingInsuranceTypeIds: this.carrierInsurance.map(o => o.insuranceTypeId),
                carrierId: this.carrierId,
                carrier: this.carrier
            }
        }).whenClosed((result) => {
            if (!result.wasCancelled) {
                this.loadCarrierActivityStream(this.carrier.uniqueId);
                return true;
            }
        });
    }

    onTransloaderLocationsGridReady() {
        this.autosizeColumns();
    }

    autosizeColumns() {
        this.transloaderLocationsGridOptions.api.columnController.autoSizeAllColumns();
    }


    newCarrier(entityType: string) {
        this.carrier = new Carrier();
        this.carrier.status = 0;
        this.carrier.id = 0;
        this.carrier.entityType = entityType;

        return Promise.resolve();
    }

    //this is for creating a new carrier record.
    //loadCarrierByDotNumber(dotNumber: string) {
    //    this.busyService.on();
    //    return this.api.get("Fmcsa", "GetCarrierFromFmcsaApi", { dotNumber: dotNumber })
    //        .then((result) => {
    //            this.carrier = Object.assign(new Carrier(), JSON.parse(result.response));
    //            this.carrier.status = 0;    //new 

    //            if (this.carrier.id) {
    //                //this.pageMessageService.setErrorMessage(`DOT # ${dotNumber} already exists in the CMP database. <a href="work-carrier/${this.carrier.id}">Click here to edit this carrier.</a>`);
    //                ////clear the carrier id, so that on save, it will fail to insert.  This will at least prevent the record
    //                ////  from being overwritten.
    //                this.busyService.off();
    //                return this.dialogService.open(
    //                    {
    //                        viewModel: CarrierExistsDialog
    //                    })
    //                    .whenClosed((result) => {
    //                        if (result.wasCancelled) {
    //                            //don't leave this view if user cancelled the dialog
    //                            return Promise.reject(false);
    //                        }
    //                        else {
    //                            if (result.output) {
    //                                //save changes if user confirmed the dialog
    //                                this.busyService.on();
    //                                return Promise.reject(new Redirect(`work-carrier/${this.carrier.id}`));
    //                            } else {
    //                                //discard changes
    //                                return Promise.reject(false);
    //                            }
    //                        }
    //                    });
    //            } else {

    //                //if legal name not populated, then not found on fmcsa site.
    //                if (!this.carrier.legalName) {
    //                    this.pageMessageService.setErrorMessage(`Automatic FMCSA lookup failed.`);
    //                    //$["notify"](`Carrier not found for specified DOT #: ${dotNumber}`, "error");
    //                }
    //            }
    //        })
    //        .finally(() => this.busyService.off());
    //}

    loadTransloaderLocations(entityId: number): any {
        return this.api.get("Carriers", "GetTransloaderLocations", { entityId: entityId })
            .then((result) => {
                //this.transloaderLocations.insideStorage = "
                let locations = JSON.parse(result.response);
                locations.forEach(o => {
                    o.accessToWater = o.accessToWater ? 'Yes' : 'No';
                    o.otrTrucks = o.otrTrucks ? 'Yes' : 'No';
                    o.railServed = o.railServed ? 'Yes' : 'No';
                });
                this.transloaderLocations = locations;
            });
    }

    loadCarrierProfile(carrierId: number) {
        this.appMessageService.clearPageScopedMessages();

        this.carrierId = carrierId;
        this.editMode = "Edit";
        this.busyService.on();
        return Promise.all([
            this.loadCarrierDetails(carrierId)
                .then(() => {
                    // these run asynchronously
                    this.loadTransloaderLocations(this.carrier.id);
                    this.loadCarrierDocuments(this.carrier.uniqueId);
                    this.loadCarrierActivityStream(this.carrier.uniqueId);
                    this.loadCarrierShipHistory(this.carrier.uniqueId);
                    this.loadCarrierCountriesOfOperation(this.carrier.uniqueId)
                }),
            this.loadCarrierRequest(carrierId),
            this.loadCarrierDotValues(carrierId),
            this.loadCarrierFieldApprovals(carrierId),
            this.loadCarrierEquipment(carrierId),
            this.loadPrimaryAgentUsers(),
            this.loadCarrierMills(carrierId),
            //this.loadCarrierEndorsements(carrierId),
            //this.loadCarrierDocuments(carrierId),
            this.loadCarrierInsurance(carrierId),
            this.loadCarrierInboundLanes(carrierId),
            this.loadCarrierOutboundLanes(carrierId),
            // this.loadIsCarrierFullyApproved(carrierId),
            this.loadCarrierContacts(carrierId),
            this.getFamilyTree(carrierId)
        ])
            .then((result) => {
                this.setOriginalCarrierJson();
                this.isSaveDisabled = false;
                this.pageMessageService.clear();
                this.clearCarrierSpecificMessages();
                this.runCarrierBusinessRules();

                if (this.carrier != null && this.currentCarrierRequest && this.currentCarrierRequest.type.value == this.REQUEST_TYPE_ID_CARRIER_ONBOARDING) {
                    this.showOnboardingRequirements = true;
                } else {
                    this.showOnboardingRequirements = false;
                }
            })
            .finally(() => this.busyService.off());
    }


    clearCarrierSpecificMessages() {
        //clear carrier-specific messages
        this.appMessageService.removeMessages((m) => m.data && m.data.carrierId == this.carrier.id);
    }


    @computedFrom("carrier", "carrier.entityType")
    public get isTrucksCarrier(): boolean {
        return this.carrier && (this.carrier.entityType == 'TRUCKS' || this.carrier.entityType == 'TRANSLOADER/TRUCKS');
    }
    @computedFrom("carrier", "carrier.entityType")
    public get isTransloaderCarrier(): boolean {
        return this.carrier && (this.carrier.entityType == 'TRANSLOADER' || this.carrier.entityType == 'TRANSLOADER/TRUCKS')
    }

    runCarrierBusinessRules() {

        // "business rules" that apply to carrier
        if (this.carrier.contractType == "Single Facility") {
            if (this.carrierDivisions.length > 1) {
                this.appMessageService.addErrorMessage("Single Facility carriers can only have one mill assigned.");
            }
            else {
                this.appMessageService.addWarningMessage("NOTE: This carrier only allowed to move freight for the selected mill.");
            }
        }
        // if (this.currentCarrierRequest) {
        //     this.appMessageService.showInfoMessage("This carrier belongs to active request <a href='/requests/" + this.currentCarrierRequest.requestId + "'>" + this.currentCarrierRequest.number + "</a>",
        //         !!this.currentCarrierRequest, true);
        // }

        this.appMessageService.showInfoMessage("This carrier is restricted to its state of domicile.",
            this.carrier.confinedToState);

        this.appMessageService.showInfoMessage("Vendor has modified Agreement.  See contract or notes for details.",
            (this.carrier.contractType || "").toLowerCase().indexOf("modified") > -1);

        this.appMessageService.showWarningMessage("Documents needed for Carriers/Brokers Profile.",
            this.carrier.documentHold);

        this.appMessageService.showWarningMessage("One or more insurance policies are canceled.",
            !!this.carrierInsurance.find(o => o.isCanceled));

        this.appMessageService.showInfoMessage("Carrier not permitted to broker loads.",
            this.carrier.typeOfAuthority == "PERMIT");

        //this.appMessageService.showInfoMessage("This carrier belongs to the parent company, " + this.carrier.parentName,
        //    !!this.carrier.parentName);

        this.appMessageService.showInfoMessage("This is a parent company.  See below for list of children.",
            !!this.carrier.children.length);


        // lock the NGTVID-related fields, if NGTVID is locked
        if (this.carrier.ngtvidLocked) {
            this.scacCodeReadonly = true;
            if (this.isTrucksCarrier) {
                this.dotNumberReadonly = true;
            } else {
                this.taxIdReadonly = true;
            }
        }

        // set DJJ flag
        if (this.carrierDivisions.find(o => [115, 1093, 1094].indexOf(o) > -1)) {
            this.isDjjCarrier = true;
        }
    }

    async setNlcApprovedForExemptCarrier() {
        await this.saveChanges(true, async () => {
            await this.api.post("Carriers", "SetNlcApprovedForExemptCarrier", { carrierId: this.carrier.id });
        });
    }

    setOriginalCarrierJson(originalObj?: any) {
        if (!originalObj) {
            originalObj = this.getCarrierUpdateObject();
        }
        this.originalCarrierJson = JSON.stringify(originalObj);
    }

    loadEquipmentTypes() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipment")
            .then((result) => {
                this.equipmentTypes = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadCountries() {
        this.busyService.on();
        this.api.get("Carriers", "GetCountries")
            .then((result) => {
                this.countries = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    loadCarrierCountriesOfOperation(carrierId: string) {
        this.busyService.on();
        this.api.get("Carriers", "GetCarrierCountriesOfOperation", { carrierId: carrierId })
            .then((result) => {
                this.carrierCountriesOfOperation = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    loadProductGroups() {
        this.busyService.on();
        this.api.get("Carriers", "GetProductGroups")
            .then((result) => {
                this.productGroups = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }


    loadPrimaryAgentUsers() {
        this.busyService.on();
        let assignableUsersCarrier: any;
        let assignableUsersTransloader: any;
        return Promise.all([
            this.api.get("Tasks", "GetGroupMembers", { groupId: TaskAssignmentGroups.carrierServices })
                .then((result) => {
                    console.log("Done1a");
                    assignableUsersCarrier = JSON.parse(result.response);
                }),
            this.api.get("Tasks", "GetGroupMembers", { groupId: TaskAssignmentGroups.transloaderServices })
                .then((result) => {
                    console.log("Done1b");
                    assignableUsersTransloader = JSON.parse(result.response);
                })
        ]).finally(() => {
            this.primaryAgentOptGroups = [
                {
                    label: "Carrier Services",
                    opts: assignableUsersCarrier
                },
                {
                    label: "Transloader Services",
                    opts: assignableUsersTransloader
                }
            ];
            this.busyService.off();
        });
    }


    async loadCarrierDetails(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierById", { carrierId: carrierId })
            .then((result) => {
                this.carrier = Object.assign(new Carrier(), JSON.parse(result.response));
                this.originalCarrierStatus = this.carrier.status;

                //set the page title
                this.router.currentInstruction.config.navModel.setTitle(this.carrier.legalName);
                this.router.updateTitle();

                //this.carrierPointUrl = this.settingsService.settings["carrierPointUrl"].replace("${carrierPointId}", this.carrier.id);
            });
    }

    scrollToRequirements() {

        // this.dialogService.open(
        //     {
        //         viewModel: CarrierOnboardingStatusSummaryDialog,
        //         model: { carrierId: this.carrier.id }
        //     })
        //     .whenClosed((result) => {
        //     });


        window.setTimeout(() => {
            window.document.getElementById("tabsSection").scrollIntoView({ behavior: 'smooth' });
        }, 0);
    }


    refresh() {
        this.loadCarrierProfile(this.carrier.id);
    }

    // loadIsCarrierFullyApproved(carrierId: number) {
    //     return this.api.get("Carriers", "IsCarrierFullyApproved", { carrierId: carrierId })
    //         .then((result) => {
    //             this.isCarrierFullyApproved = JSON.parse(result.response);
    //         });
    // }


    //loadCarrierComments(carrierId: number) {
    //    return this.api.get("Carriers", "GetCarrierComments", { carrierId: carrierId })
    //        .then((result) => {
    //            const comments: CommentEntry[] = JSON.parse(result.response);
    //            this.carrierComments = comments;

    //            this.carrierCommentTagCount = {};
    //            this.carrierComments.forEach((c) => {
    //                if (c.tags) {
    //                    c.tags.toLowerCase().split(',').forEach(tag => {
    //                        this.carrierCommentTagCount[tag] = this.carrierCommentTagCount[tag] || 0;
    //                        this.carrierCommentTagCount[tag]++;
    //                    });
    //                }
    //            });
    //        });
    //}

    loadCarrierActivityStream(carrierId: string) {
        return this.api.get("Carriers", "GetCarrierActivityStream", { carrierId: carrierId })
            .then((result) => {

                const entries: any[] = JSON.parse(result.response);

                this.carrierCommentTagCount = {};
                entries.forEach((c) => {
                    if (c.type == "comment" && c.tags) {
                        c.tags.toLowerCase().split(',').forEach(tag => {
                            this.carrierCommentTagCount[tag] = this.carrierCommentTagCount[tag] || 0;
                            this.carrierCommentTagCount[tag]++;
                        });
                    }

                    c.insertedOnFormatted = moment(c.insertedOn).format('YYYY-MM-DD hh:mm a');
                });

                this.carrierActivityStream = entries;

            });
    }

    // public usDotStatusValueMap = {
    //     'A': 'ACTIVE',
    //     'I': 'INACTIVE'
    // }

    // public showUsDotStatusInstructionAlert() {
    //     alert("This status cannot be updated directly.");
    // }

    async loadCarrierContacts(carrierId: number) {
        let result = await this.api.get("Carriers", "GetCarrierContacts", { carrierId: carrierId });
        var contacts = JSON.parse(result.response);
        this.contacts = contacts;
        ////populate the millCodes array
        //contacts.forEach(contact => {
        //    if (contact.mills.length == 0) {
        //        contact.mills = this.carrierDivisions.map(carrierMillId => {
        //            return this.divisions.find(item => item.id == carrierMillId) || {};
        //        });
        //        contact.millCodeList = "All Mills";
        //    } else {
        //        contact.mills = contact.millIds.map(carrierMillId => {
        //            return this.divisions.find(item => item.id == carrierMillId) || {};
        //        });
        //        contact.millCodeList = contact.millIds.map(carrierMillId => {
        //            return (this.divisions.find(item => item.id == carrierMillId) || {}).millId;
        //        }).join(",")
        //    }
        //});
    }

    loadCarrierFieldApprovals(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierFieldApprovals", { carrierId: carrierId })
            .then((result) => {
                this.fieldApprovals = JSON.parse(result.response);
            });
    }
    loadCarrierDotValues(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierDotValues", { carrierId: carrierId })
            .then((result) => {
                const newDotValue = JSON.parse(result.response) || {};
                // Set all existing keys to null for this.dotValues so the UI will auto refresh
                for (let key in this.dotValues) {
                    if (this.dotValues.hasOwnProperty(key)) {
                        this.dotValues[key] = null;
                    }
                }
                // Merge the new dot values into the existing dotValues object
                Object.assign(this.dotValues, newDotValue);
            });
    }

    loadCarrierEquipment(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierEquipment", { carrierId: carrierId })
            .then((result) => {
                let carrierEquipment = JSON.parse(result.response);
                this.carrierEquipment = carrierEquipment.map((item) => {
                    return item.id;
                });
                this.originalCarrierEquipment = carrierEquipment.map((item) => {
                    return item.id;
                });
            });
    }

    loadCarrierMills(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierMills", { carrierId: carrierId })
            .then((result) => {

                let carrierMills = JSON.parse(result.response);

                this.tmsFlag = !carrierMills.find(o => o.tms != true);

                this.originalCarrierDivisions = carrierMills.map((item) => {
                    return item.id;
                });
                this.carrierDivisions = carrierMills.map((item) => {
                    return item.id;
                });


                var carrierMillCodes = carrierMills.map((item) => {
                    return item.code;
                });
                this.isCarrierEnabledForMyMill = false;
                this.securityService.user.millCodes.forEach(myMillCode => {
                    if (carrierMillCodes.indexOf(myMillCode) > -1) this.isCarrierEnabledForMyMill = true;
                });

            });
    }

    //loadCarrierEndorsements(carrierId: number) {
    //    return this.api.get("Carriers", "GetCarrierEndorsements", { carrierId: carrierId })
    //        .then((result) => {
    //            this.carrierEndorsements = JSON.parse(result.response);
    //        });
    //}

    loadCarrierDocuments(carrierGuid: string) {
        return this.api.get("Carriers", "GetCarrierDocuments", { carrierGuid: carrierGuid })
            .then((result) => {
                this.carrierDocuments = JSON.parse(result.response);
            });
    }

    loadCarrierInboundLanes(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierInboundLanes", { carrierId: carrierId })
            .then((result) => {
                this.carrierInboundLanes =
                    JSON.parse(result.response).map(item => item.laneCode);
            });
    }

    loadCarrierOutboundLanes(carrierId: number) {
        return this.api.get("Carriers", "GetCarrierOutboundLanes", { carrierId: carrierId })
            .then((result) => {
                this.carrierOutboundLanes = JSON.parse(result.response).map(item => item.laneCode);
            });
    }

    loadCarrierStatuses() {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierStatuses")
            .then((result) => {
                this.carrierStatuses = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    loadCarrierShipHistory(carrierId: string) {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierShipHistory", { carrierId: carrierId })
            .then((result) => {
                this.carrierShipHistory = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    async loadCarrierRequest(carrierId: number) {
        this.carrierIsOnboarding = false;
        const result = await this.api.get("Carriers", "GetCarrierRequest", { carrierId: this.carrierId, includeClosed: false });
        if (result.response) {
            this.currentCarrierRequest = JSON.parse(result.response) as RequestDto;
            this.carrierIsOnboarding = this.currentCarrierRequest && !this.currentCarrierRequest.variables.IsReevaluationRequest && !this.currentCarrierRequest.variables.IsDormancyReviewRequest && !this.currentCarrierRequest.variables.IsInsuranceRenewalRequest;
        }

        if (this.carrierIsOnboarding) {
            this.selectedTab = "onboarding-requirements";
        } else {
            this.selectedTab = "comments";
        }
    }

    //loadInsuranceTypes() {
    //    this.busyService.on();
    //    return this.api.get("Carriers", "GetInsuranceTypes")
    //        .then((result) => {
    //            this.insuranceTypes = JSON.parse(result.response);
    //        })
    //        .finally(() => this.busyService.off());
    //}

    refreshInsurance() {
        this.loadCarrierInsurance(this.carrier.id);
        this.setOriginalCarrierJson();
    }

    loadCarrierInsurance(carrierId: number) {
        this.busyService.on();
        return this.api.get("Carriers", "GetCarrierInsurance", { carrierId: carrierId })
            .then((result) => {
                this.carrierInsurance = JSON.parse(result.response);
                //insuranceForReview = legacy insurance records that have not been properly categorized.
                this.insuranceForReview = this.carrierInsurance.filter(o => o.authorityTypeId == "035f19f2-bfeb-47cf-b355-4c63eddbbf0c");
                this.brokerageInsurance = this.carrierInsurance.filter(o => o.authorityTypeId == "ec8d37e1-a1ed-4187-9455-f41b8900088b");
                this.assetCarrierInsurance = this.carrierInsurance.filter(o => o.authorityTypeId == "30d0f5ca-81a4-4540-b8a5-cf605bd523e8");

                //set the "expired" property
                this.carrierInsurance.forEach(m => m.expired = moment(new Date()).isAfter(m.expiration, 'day'));

                // set flags for UI
                this.hasInsuranceThatNeedsReview = this.insuranceForReview.length > 0;
                this.hasBrokerInsurance = this.brokerageInsurance.length > 0;
                this.hasCarrierInsurance = this.assetCarrierInsurance.length > 0;

                //run business rules
                this.appMessageService.showWarningMessage("One or more insurance policies for this carrier have expired.",
                    this.carrier.status == 8 && this.carrierInsurance.find(m => m.expired));

                this.appMessageService.showWarningMessage("INSURANCE NEEDS REVIEW", this.hasInsuranceThatNeedsReview);

            })
            .finally(() => this.busyService.off());
    }

    loadDivisions() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                this.divisions = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }

    printApplication() {
        this.carriersController.printApplication(this.carrier.id, this.carrier.legalName);
    }
    approveCarrier() {
        this.carrier.status = 2;    //move status from "new" to "potential"
        this.saveChanges();
    }

    printComments(): void {
        var parameters = {
            filename: `Carrier Activity - ${this.carrier.legalName || this.carrier.dbaName}`,
            reportFragment: encodeURIComponent(`CarrierActivity&id=${this.carrier.id}&commentTagFilter=${this.commentTagFilter}`),
            format: "PDF"
        };
        const url = "/Report/Download" + this.getQueryString(parameters);
        window.open(url);

        //var reportFragment = encodeURIComponent("MillCarrierStatus&millId=" + this.millId);
        //window.open("/Report/Download?fileName=" + encodeURIComponent(this.fileName) + "&reportFragment=" + reportFragment + "&format=" + this.format);
    }

    private getQueryString(parameters, asAdditionalParameters = false) {
        let s = asAdditionalParameters ? "&" : "?";
        for (let key of Object.keys(parameters)) {
            s += `${key}=${parameters[key]}&`;
        }
        return s;
    }

    //setEndorsementDate(endorsement) {
    //    endorsement.endorsementDate = new Date();
    //}
    setDocumentReceivedDate(document) {
        document.documentReceivedDate = new Date();
    }
    getStatusDescription(statusId) {
        if (this.carrierStatuses) {
            var item = this.carrierStatuses.find(o => o.id == statusId);
            return item && item.description;
        }
        return "";
    }

    async changeStatus() {
        this.changeStatusNoDirtyCheck();

        // if (this.formIsDirty()) {
        //     this.dialogService.open({
        //         viewModel: SimpleDialog,
        //         model: {
        //             title: "Unsaved Changes",
        //             icon: "fa-exclamation-triangle",
        //             message: "Please save changes before changing status.",
        //             buttons: ["Ok"]
        //         }
        //     });
        // } else {
        //     this.changeStatusNoDirtyCheck();
        // }
    }

    changeStatusNoDirtyCheck() {

        this.dialogService.open(
            {
                viewModel: CarrierStatusDialog,
                model: { carrier: this.carrier }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {

                    //notify that state changed
                    $["notify"](`State changed to ${this.getStatusDescription(result.output.status)}`, { className: "success", position: "top center" });
                }
            });
    }

    editDedicatedScacCodes() {

        this.dialogService.open({
            viewModel: DedicatedScacDialog,
            model: [
                this.carrier.id,
                this.carrier.dbaName || this.carrier.legalName,
                this.carrier.dedicatedScacCodes,
                this.carrier.scacCode,
                this.scacCodeReadonly
            ]
        }).whenClosed((result) => {
            if (!result.wasCancelled) {
                const obj = result.output;
                this.carrier.dedicatedScacCodes = obj.dedicatedScacCodes;
                this.carrier.scacCode = obj.scacCode;
                //reload carrier
                // this.loadCarrierDetails(this.carrier.id);
            }
        });
    }


    editAdditionalMcNumbers() {

        this.dialogService.open({
            viewModel: UpdateAdditionalMcNumberDialog,
            model: [
                this.carrier.id,
                this.carrier.dbaName || this.carrier.legalName,
                this.carrier.additionalMcNumbers,
                this.carrier.mcNumber
            ]
        }).whenClosed((result) => {
            if (!result.wasCancelled) {
                const obj = result.output;
                this.carrier.mcNumber = obj.primaryMcNumber;
                this.carrier.additionalMcNumbers = obj.additionalMcNumbers;
                //reload carrier
                //this.loadCarrierDetails(this.carrier.id);
            }
        });
    }

    private formIsDirty(): Boolean {
        var currentCarrierUpdateObj = this.getCarrierUpdateObject();
        var currentCarrierJson = JSON.stringify(currentCarrierUpdateObj);
        const isDirty = this.originalCarrierJson != currentCarrierJson;
        return isDirty;
    }

    canDeactivate() {

        //return new Promise((a, b) => { });

        if (!this.securityService.hasRole("edit")) {
            return true;
        }

        // check for insurance sync needed
        if (this.insuranceSyncNeeded) {
            return this.dialogService.open(
                {
                    viewModel: SimpleDialog,
                    model: {
                        title: "Insurance Sync Required",
                        message: "Insurance information has been changed - sync is required.",
                        buttons: ["Ok"]
                    }
                })
                .whenClosed((result) => {
                    return false;
                });
        }

        //prompt to save changes, if anything changed.
        if (this.formIsDirty()) {
            return this.dialogService.open(
                {
                    viewModel: SaveChangesDialog
                })
                .whenClosed((result) => {
                    if (result.wasCancelled) {
                        //don't leave this view if user cancelled the dialog
                        return Promise.reject(false);
                    }
                    else {
                        if (result.output) {
                            //save changes if user confirmed the dialog
                            return this.saveChanges();
                        } else {
                            //discard changes
                            return Promise.resolve();
                        }
                    }
                });
        }
    }

    deleteCarrier(deleted) {
        if (this.carrier.id) {
            this.busyService.on();
            return this.api.post("Carriers", "DeleteCarrier", { id: this.carrier.id, deleted: deleted })
                .then((result) => {
                    this.appMessageService.addErrorMessage(`Carrier ${deleted ? '' : 'un-'}deleted.`);

                    //reload page
                    this.loadCarrierProfile(this.carrier.id);

                })
                .finally(() => {
                    this.ea.publish("carrier.save", this.carrier);
                    this.busyService.off();
                });
        }
    }

    async refreshFromFMCSA() {
        // Add some pre-validation to make experience smoother for users
        if (!this.carrier.dotNumber) {
            this.appMessageService.addErrorMessage("DOT # is required for FMCSA refresh");
        }
        else if (this.carrier.dotNumber.length > 10) {
            this.appMessageService.addErrorMessage("DOT # must be 10 digits or less.");
        }

        if (this.carrier.id) {
            this.busyService.on();
            return this.api.post("Carriers", "UpdateCarrierFromFmcsaApi", { id: this.carrier.id })
                .then(async (result) => {
                    const fmcsaApiCarrierResult = JSON.parse(result.response);
                    if (fmcsaApiCarrierResult.status == ApiResultStatus.success) {
                        if (fmcsaApiCarrierResult.value) {
                            await this.loadCarrierDetails(this.carrier.id);
                            this.appMessageService.addSuccessMessage("Carrier information has been updated from FMCSA");
                        } else {
                            this.appMessageService.addErrorMessage("Carrier could not be found in FMCSA");
                        }
                    } else if (fmcsaApiCarrierResult.status == ApiResultStatus.failed) {
                        this.appMessageService.addWarningMessage("Error updating carrier from FMCSA.  Contact support for details.");
                    } else if (fmcsaApiCarrierResult.status == ApiResultStatus.disabled) {
                        this.appMessageService.addWarningMessage("FMCSA Api is not current enabled.  Contact support for details.");
                    }
                })
                .finally(() => {
                    this.ea.publish("carrier.save", this.carrier);
                    this.busyService.off();
                });
        }
    }

    togglePriority() {

        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: {
                    title: "Priority status for " + this.carrier.getCarrierName(),
                    message: this.carrier.priority ? "Priority status is currently enabled for " + this.carrier.getCarrierName() + ".\n\nDo you want to clear priority status?"
                        : "Do you want to enable priority status for " + this.carrier.getCarrierName() + "?",
                    buttons: ["yes", "no"]
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "yes") {
                        //save changes if user confirmed the dialog
                        this.carrier.priority = !this.carrier.priority;
                        this.saveChanges();
                    }
                }
            });
    }

    toggleDocumentHold() {

        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: {
                    title: "Document Hold for " + this.carrier.getCarrierName(),
                    message: this.carrier.priority ? "Document Hold is currently enabled for " + this.carrier.getCarrierName() + ".\n\nDo you want to clear the Document Hold flag?"
                        : "Do you want to enable Document Hold flag for " + this.carrier.getCarrierName() + "?",
                    buttons: ["yes", "no"]
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "yes") {
                        //save changes if user confirmed the dialog
                        this.carrier.documentHold = !this.carrier.documentHold;
                        this.saveChanges();
                    }
                }
            });
    }

    async saveChanges(showConfirmation: boolean = true, thenFn?: any) {
        this.pageMessageService.clear();

        if (!this.carrier.entityType) {
            this.appMessageService.addErrorMessage("Entity Type must be selected.");
            return;
        }

        if (this.carrier.carrierPointId) {
            this.carrier.carrierPointId = (this.carrier.carrierPointId || "").replace(/ /g, '').replace(/,/g, ', ');
            var ids = this.carrier.carrierPointId.split(',');
            var invalidCarrierPointId = ids.find(o => !!o.trim().match(/[^0-9]/g));
            if (invalidCarrierPointId) {
                this.appMessageService.addErrorMessage("Carrier Point IDs must be numeric only values.  Multiple IDs should be separated by a comma.");
                return;
            }
        }
        var params = this.getCarrierUpdateObject();

        if (!this.carrier.id) {

            this.busyService.on();

            //insert new carrier record
            return this.api.submit("Carriers", "UpdateCarrier", params)
                .then((result) => {
                    var responseObj = JSON.parse(result.response);
                    var carrierId = responseObj.id;
                    this.appMessageService.addSuccessMessage("New carrier application created.");

                    //reset originalJson object to prevent any save prompts during navigation.
                    // this is necessary because we don't reload the carrier profile after an insert;
                    //   instead, we redirect to the entity's url.
                    this.setOriginalCarrierJson();
                    this.router.navigate(`work-carrier/${carrierId}`, { replace: true });
                }, (error) => {
                    //scroll to top of page to ensure error is visible
                    window.scrollTo(0, 0);
                })
                .finally(() => {
                    this.ea.publish("carrier.save", this.carrier);
                    this.busyService.off();
                });
        } else {

            // UPDATES

            // Check to see if any basic info fields changed since last load, and require comment before saving
            const canContinue = await this.collectCommentBeforeSave(params);
            if (!canContinue) return;

            this.busyService.on();

            return this.api.submit("Carriers", "UpdateCarrier", params)
                .then(async (result) => {
                    var responseObj = JSON.parse(result.response);

                    //update the version string so that consecutive saves are possible
                    this.carrier.versionCol = responseObj.versionCol;
                    if (showConfirmation) this.appMessageService.addSuccessMessage("Carrier updated.");


                    //// update the JSON that is used when navigating away to determine whether changes made been made.
                    //this.setOriginalCarrierJson();

                    // optional function to execute after save, but before refreshing the screen data
                    if (thenFn) {
                        this.busyService.off();
                        await thenFn.apply(this);
                    }

                    //reload page
                    await this.loadCarrierProfile(this.carrier.id);

                    ////reload endorsements
                    //this.loadCarrierEndorsements(this.carrier.id);
                    ////reoad insurance records
                    //this.loadCarrierInsurance(this.carrier.id);
                }, (error) => {
                    //scroll to top of page to ensure error is visible
                    window.scrollTo(0, 0);
                })
                .finally(() => {
                    this.ea.publish("carrier.save", this.carrier);
                    this.busyService.off();
                });

        }
    }


    private async collectCommentBeforeSave(params: UpdateCarrierModel): Promise<boolean> {
        const nu: UpdateCarrierModel = params;
        const old: UpdateCarrierModel = JSON.parse(this.originalCarrierJson);

        const fieldsToCheck = [
            "entityType",
            "legalName",
            "alternateName",
            "dotNumber",
            "dbaName",
            "typeOfAuthority",
            "scacCode",
            "dedicatedScacCodes",
            "taxId",
            "mcNumber",
            "confinedToState",
            "dedicatedFleet",
            "legalAddressStreet",
            "legalAddressCity",
            "legalAddressZip",
            "legalAddressState",
            "legalAddressCountry",
            "mainPhone",
            "mainPhoneExt",
            "preferredInboundLanes",
            "preferredOutboundLanes",
            "numberOfTrucks",
            "equipment",
            "communicationType",
            "safetyRating",
            "heavyHauler",
            "heavyHaulerWeightId",
            "overlengthHauler",
            "diversityCertified",
            "hazmatCertified",
            "hasSustainabilityProgram",
            "sustainability",
            "sustainabilityProgram",
            "divisions",
        ]

        const changedFields = [];

        fieldsToCheck.forEach(field => {
            this.checkFieldForChanges(nu, old, field, changedFields);
        });

        if (changedFields.length) {

            var fieldChangeSummary = "The following fields were modified:";

            changedFields.forEach(field => {
                var oldValue = this.getDisplayValueForField(old, field);
                var newValue = this.getDisplayValueForField(nu, field);

                fieldChangeSummary += "\n  - " + field + " changed from \"" + oldValue + "\" to \"" + newValue + "\"";
            });

            var model = {
                title: "Comment Required",
                message: "Please provide a comment to describe the reason for these changes:",
                showComment: true,
                comment: "",
                buttons: ["Save", "Cancel"]
            };

            return await this.dialogService.open(
                {
                    viewModel: SimpleDialog,
                    model: model
                })
                .whenClosed((result) => {
                    if (result.output == "Save") {
                        if (model.comment.trim().length > 10) {

                            params.comment = "Basic Info updated.  Comment: " + model.comment + "\n\n" + fieldChangeSummary;

                            return true;
                        } else {
                            alert("Valid Comment is Required.");
                        }
                    }
                });
        } else {
            return true;
        }
    }

    checkFieldForChanges(nu: UpdateCarrierModel, old: UpdateCarrierModel, field: string, changedFields: any[]) {
        var oldValue = this.getDisplayValueForField(old, field);
        var newValue = this.getDisplayValueForField(nu, field);

        // flag field as changed
        if (oldValue != newValue) {
            changedFields.push(field);
        }
    }

    getDisplayValueForField(carrierUpdateModel: UpdateCarrierModel, field: string) {
        var value = carrierUpdateModel.carrier[field];
        let displayValue = value;

        if (Array.isArray(carrierUpdateModel.carrier[field])) {
            var nuArr = carrierUpdateModel.carrier[field] || [];
            displayValue = nuArr.sort().join(",");
        }

        if (field == "equipment") {
            const values = carrierUpdateModel.equipment;
            const items = this.equipmentTypes.filter(o => values.indexOf(o.id) > -1);
            displayValue = items.map(o => o.description).sort().join(", ");
        }

        if (field == "divisions") {
            const values = carrierUpdateModel.divisions;
            const items = this.divisions.filter(o => values.indexOf(o.id) > -1);
            displayValue = items.map(o => o.millId).sort().join(", ");
        }

        if (field == "preferredInboundLanes") {
            const values = carrierUpdateModel.inboundLanes;
            displayValue = values.sort().join(", ");
        }

        if (field == "preferredOutboundLanes") {
            const values = carrierUpdateModel.outboundLanes;
            displayValue = values.sort().join(", ");
        }


        return displayValue || "";

    }


    loadHeavyHaulerWeights() {
        this.busyService.on();
        this.api.get("Carriers", "GetHeavyHaulerWeights")
            .then((result) => {
                this.heavyHaulerWeights = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }

    getCarrierUpdateObject(): UpdateCarrierModel {

        //handle number fields
        if (isNaN(parseInt(this.carrier.numberOfTrucks + ""))) {
            this.carrier.numberOfTrucks = undefined;
        } else {
            this.carrier.numberOfTrucks = parseInt(this.carrier.numberOfTrucks + "");
        }

        // don't include hasSustainabilityProgram property when comparing, since it's not a server-side field
        delete this.carrier.hasSustainabilityProgram;

        // don't include ospCarrierProductGroups_String property when comparing, since it shouldnt be populated directly
        delete this.carrier["ospCarrierProductGroups"];


        var updateObj = {
            comment: "",
            carrier: this.carrier,
            equipment: this.carrierEquipment,
            divisions: this.carrierDivisions,
            inboundLanes: this.carrierInboundLanes,
            outboundLanes: this.carrierOutboundLanes,
            countriesOfOperation: this.carrierCountriesOfOperation
        };
        return updateObj;
    }

    isDotMatch(carrierField, dotMatch, compareType) {

        if (!dotMatch) return true;

        if (dotMatch.fmcsaDiscrepancyApproved) {
            return true;
        }
        carrierField = carrierField || "";
        var dotMatchValue = dotMatch.dotValue || "";

        if (compareType == "phone") {
            var converter = new PhoneValueConverter();
            dotMatchValue = converter.format(dotMatchValue);
        }

        return carrierField.toString().trim().toLowerCase() == dotMatchValue.toString().trim().toLowerCase();
    }

    changeParent() {
        return this.dialogService.open(
            {
                viewModel: SearchCarrierDialog
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    var parentId = result.output;
                    if (parentId) {
                        this.carrier.parent = parentId;
                        this.saveChanges();
                    }
                }
            });
    }

    //removeParent() {
    //    return this.dialogService.open(
    //        {
    //            viewModel: SimpleDialog,
    //            model: {
    //                title: "Remove parent for " + this.carrier.getCarrierName(),
    //                message: "Do you want to clear the parent link for this carrier?",
    //                buttons: ["yes", "no"]
    //            }
    //        })
    //        .whenClosed((result) => {
    //            if (!result.wasCancelled) {
    //                if (result.output == "yes") {
    //                    this.carrier.parent = null;
    //                    this.saveChanges();
    //                }
    //            }
    //        });
    //}

    getApprovalClass(fieldName) {
        var className = this.fieldApprovals[fieldName] ? 'has-approval' : '';
        return className;
    }

    applyDotValue(fieldName, formatterType) {
        if (this.securityService.hasRole("edit")) {

            var dotValue = this.dotValues[fieldName].dotValue;
            if (formatterType == "phone") {
                var converter = new PhoneValueConverter();
                dotValue = converter.format(dotValue);
            }
            this.carrier[fieldName] = dotValue;
        }
    }




    public async approveFmcsaDiscrepancy(fieldName) {
        var model = {
            title: "Ignore/Override FMCSA Discrepancy (keep CMP value)",
            message: "The FMCSA value for this field differs from the specified value in CMP.   \n\nOnce this is override is created, the system will no longer flag this as a discrepancy.\n\nProvide a justification below for keeping the CMP value:",
            showComment: true,
            comment: "",
            buttons: ["Override", "Cancel"]
        };


        return await this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: model
            })
            .whenClosed((result) => {
                if (result.output == "Override") {
                    if (model.comment.trim().length > 10) {

                        var params = {
                            carrierId: this.carrier.id,
                            carrierField: fieldName,
                            fmcsaDiscrepancyApproved: true,
                            fmcsaDiscrepancyApprovalReason: model.comment
                        };

                        this.api.submit("Carriers", "UpdateFmcsaFieldApproval", params)

                        // refresh the dot values
                        this.dotValues[fieldName] = null;


                        return true;
                    } else {
                        alert("Valid Comment is Required.");
                    }
                }
            });
    }

    //@computedFrom("carrierInsurance.length")
    //get carrierInsuranceHasItems(): boolean {
    //    return !!this.carrierInsurance.filter((ins) => ins.name != 'DELETED').length;
    //}
    @computedFrom("carrier", "carrier.status", "carrierStatuses.length")
    get carrierStatusDescription(): string {
        if (this.carrier) {
            return this.getStatusDescription(this.carrier.status);
        }
        return "";
    }

    @computedFrom("carrier", "carrier.status", "carrierStatuses.length")
    get carrierStatusClass(): string {
        let clss = "";
        if (this.carrier) {
            const statusDescription = this.getStatusDescription(this.carrier.status);
            const isDoNotUseStatus = statusDescription.toLowerCase().indexOf("do not use") > -1;
            if (isDoNotUseStatus) {
                clss = "status-donotuse";
            } else if (this.carrier.status == 8) {
                if (this.carrier.contractType == "Single Facility") {
                    clss = "status-approved-single-facility";
                } else {
                    clss = "status-approved";
                }
            }
        }
        return clss;
    }


    preInitTransloaderLocationsGrid() {
        //set up grid options
        this.transloaderLocationsGridOptions = {
            api: undefined,
            columnDefs: this.transloaderLocationsGridColumnDefs,
            //pagination controls require v9 or greater.
            pagination: true,
            paginationPageSize: 100,
            //paginationAutoPageSize : true
        };
    }


    private transloaderLocationsGridColumnDefs: Array<any> = [
        { field: "id", hide: true },
        {
            headerName: "Location Code", field: "locationName", filter: 'text',
            cellRenderer: (params) => this.transloaderLocationsLinkCellRenderer(params)
        },
        { headerName: "Phone Number", field: "phoneNumber", filter: 'text' },
        { headerName: "Address", field: "address1", filter: 'text' },
        { headerName: "City", field: "city", filter: 'text' },
        { headerName: "State", field: "state", filter: 'text' },
        { headerName: "Inside Sq Ft", field: "insideStorage", filter: 'text' },
        { headerName: "Outside Acres", field: "outsideStorage", filter: 'text' },
        { headerName: "Rail Served", field: "railServed", filter: 'text' },
        { headerName: "Railroads", field: "railroads", filter: 'text' },
        { headerName: "Rail Car Types", field: "railCarTypes", filter: 'text' },
        { headerName: "Access to Water", field: "accessToWater", filter: 'text' },
        { headerName: "OTR Trucks", field: "otrTrucks", filter: 'text' },
    ];

    public transloaderLocationsRowClick($event: MouseEvent) {
        var id = (<any>$event.srcElement).getAttribute("data-id");
        if (id) {
            this.updateTransloaderLocations(id);
        }
    }
    updateTransloaderLocations(id: string): any {
        this.dialogService.open(
            {
                viewModel: UpdateTransloaderLocationDialog,
                model: {
                    divisions: this.divisions,
                    carrierDivisions: this.carrierDivisions,
                    carrierId: this.carrier.id,
                    detailsId: id
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    //reload carrier comments
                    this.loadTransloaderLocations(this.carrier.id);
                }
            });
    }

    transloaderLocationsLinkCellRenderer(params: any) {
        if (params.value != null) {
            return `<a data-id='${params.api.getValue("id", params.node)}')">${params.value}</a>`;
        }
        return params.value;
    }


    async getFamilyTree(carrierId) {
        var result = await this.api.get("carriers", "GetFamilyTree", { carrierId: carrierId });
        var flatTree = JSON.parse(result.response);
        this.familyTree = unflatten(flatTree);


        function unflatten(items) {
            return items.reduce(insert, {
                res: [],
                map: {}
            }).res;
        }

        function insert(obj, item) {
            var parent = item.parent;
            var map = obj.map;
            map[item.id] = item;

            if (parent === null) obj.res.push(item);
            else {
                var parentItem = map[parent];

                if (parentItem.hasOwnProperty("children"))
                    parentItem.children.push(item);
                else parentItem.children = [item];
            }

            return obj;
        }
    }

    removeNodeFn = async (item: OrgStructureNode, which: "self" | "children") => {

        let msg: string = "";
        let title: string = "";
        switch (which) {
            case "self":
                msg = "Do you want to disconnect " + item.legalName + " from its parent?";
                title = "Remove Parent";
                break;
            case "children":
                msg = "Do you want to disconnect all children from " + item.legalName + "?";
                title = "Remove Children";
        }

        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: {
                    title: title,
                    message: msg,
                    buttons: ["yes", "no"]
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "yes") {
                        if (which == "self") {
                            this.api.post("Carriers", "RemoveCarrierParent", { childId: item.id })
                                .then(() => {
                                    this.getFamilyTree(this.carrier.id);
                                });
                        } else {
                            this.api.post("Carriers", "RemoveCarrierChildren", { parentId: item.id })
                                .then(() => {
                                    this.getFamilyTree(this.carrier.id);
                                });
                        }
                    }
                }
            });


        //alert("Functionality coming soon...");
        return;
        if (item.children.length) {
            alert("This node cannot be removed from the hierarchy until all children have been removed.");
        } else {
            if (confirm("Do you want to remove " + item.legalName)) {
                await this.api.post("Carriers", "RemoveCarrierParent");
            }
        }
    }

    addNodeFn = async (item: OrgStructureNode, which: "parent" | "child") => {

        let title: string = "";
        let msg: string = "";
        switch (which) {
            case "parent":
                title = "Add Parent";
                msg = "Do you want to add a parent to " + item.legalName + "?";
                break;
            case "child":
                title = "Add Child";
                msg = "Do you want to add a child to " + item.legalName + "?";
        }



        return this.dialogService.open(
            {
                viewModel: SimpleDialog,
                model: {
                    title: title,
                    message: msg,
                    buttons: ["yes", "no"]
                }
            })
            .whenClosed((result) => {
                if (!result.wasCancelled) {
                    if (result.output == "yes") {
                        // let user search for carrier
                        return this.dialogService.open(
                            {
                                viewModel: SearchCarrierDialog
                            })
                            .whenClosed((result) => {
                                if (!result.wasCancelled) {
                                    var parent = result.output;
                                    if (parent) {

                                        let childId: number;
                                        let parentId: number;
                                        if (which == "parent") {
                                            childId = item.id;
                                            parentId = parent.id;
                                        } else {
                                            childId = parent.id;
                                            parentId = item.id;
                                        }

                                        this.api.post("Carriers", "SetCarrierParent", { childId: childId, parentId: parentId })
                                            .then(() => {
                                                this.getFamilyTree(this.carrier.id);
                                            });
                                    }
                                }
                            });

                    }
                }
            });


        //  alert("Functionality coming soon...");
    }



}


export class UpdateCarrierModel {

    public comment: string;

    public carrier: Carrier;

    public equipment: Array<number>;

    public divisions: Array<number>;

    public inboundLanes: Array<string>;

    public outboundLanes: Array<string>;
}